/**
 * Maps i18n language code to a flag under `/public/flags/{base}.svg`.
 */
export function getPublicFlagUrl(languageCode) {
  if (!languageCode || typeof languageCode !== "string") {
    return "/flags/en.svg";
  }
  const base = languageCode.split("-")[0].toLowerCase();
  return `/flags/${base}.svg`;
}
